var React = require('react');

function IconCopy (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M750.8 107.8c-5.6-5.7-13.3-8.8-21.3-8.8l-303.6.8c-5.5 0-10 4.5-10 10l-.1 19.3v608.5l.1 20c0 5.5 4.5 10 10 10h489.5c5.5 0 10-4.5 10-10V295.9c0-7.9-3.1-15.5-8.7-21.1l-165.9-167zm114.8 201H715.8V158.9h1.3l148.5 149.9zM476 707.4V158.9h179.8v179.2c0 16.6 12.7 30.6 29.3 30.6h180.5v338.7H476zM105.9 257.8c-5.5 0-10 4.5-10 10v649.4c0 5.5 4.5 10 10 10h489.8c5.5 0 9.9-4.4 10-9.8l-.7-83.3h-59l-.5 33.1H155.9V317.7h162.5v-59.9"}));
}

IconCopy.displayName = "IconCopy";

IconCopy.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconCopy;

IconCopy.default = IconCopy;
